// extracted by mini-css-extract-plugin
export default {"loadingContainer":"style_loadingContainer__hAlXF","spinner":"style_spinner__ihf2u","spin":"style_spin__hvuV5","text":"style_text__nf5Nj"};